import { LatestUsage } from "@hydrologiq/schemas/1.0.0/installationPage"
import Energy from "../../../figures/Energy"
import { EnergyPeriod, EnergyUnit } from "@hydrologiq/common/types/energy/consumption"
import { useQuery } from "@apollo/client"
import { Text } from "@chakra-ui/react"
import { IANATimeZone, toTimestamp } from "@hydrologiq/common/helpers/date"
import { DateTime } from "timezonecomplete"
import { InstallationLatestDocument } from "@hydrologiq/gql/graphql"

export interface LatestUsageFigureProps {
  title: string
  usage: LatestUsage
  installationId: string
  installationEndDate: DateTime
}

function LatestUsageFigure({ title, usage, installationId, installationEndDate }: LatestUsageFigureProps) {
  const { loading, error, data } = useQuery(InstallationLatestDocument, {
    variables: {
      id: installationId,
      field: usage.field,
      stop: toTimestamp(installationEndDate, true),
      location: IANATimeZone(),
    },
  })

  return (
    <Energy
      heading={title}
      desiredUnit={usage.desiredUnit as EnergyUnit}
      quantity={data && data.latest ? (data.latest.value as number) : 0}
      period={EnergyPeriod.LATEST}
      previousQuantity={0}
      dp={1}
      sourceUnit={usage.sourceUnit && (usage.sourceUnit as EnergyUnit)}
      loading={loading}
      error={error ? error.message : undefined}
    />
  )
}

export default LatestUsageFigure
